var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.846,
    height: 24,
    viewBox: "0 0 25.846 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check2-circle",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3523",
    "data-name": "Pfad 3523",
    d: "M3.346,13.5a10.153,10.153,0,0,1,15.23-8.795.923.923,0,1,0,.923-1.6,12,12,0,1,0,6,10.393.923.923,0,1,0-1.846,0,10.153,10.153,0,0,1-20.307,0Z",
    transform: "translate(-1.5 -1.499)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3524",
    "data-name": "Pfad 3524",
    d: "M24.538,4.077A.924.924,0,1,0,23.231,2.77L10.962,15.041,6.077,10.154A.924.924,0,0,0,4.77,11.461L10.308,17a.923.923,0,0,0,1.307,0Z",
    transform: "translate(1.038 -0.653)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.d4ad74c9.svg";
export { ForwardRef as ReactComponent };